module.exports = __webpack_public_path__ + "static/media/step6.ccf6ea19.svg";